import { Subject, interval, takeUntil } from 'rxjs';
import { OccurrenceService } from './../../../service/occurrence.service';
import { UpcomingService } from './../../../service/upcoming.service';
import { HttpParams } from '@angular/common/http';
import { AuthenticationService } from './../../../service/authentification.service';
import { Teacher } from './../../../model/teacher.model';
import { Occurrence } from '../../../model/occurrence.model';
import { FormationService } from '../../../service/formation.service';
import { Formation } from '../../../model/formation.model';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { environment } from '../../../../../../environments/environment';
import moment from 'moment';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { nextEvent } from '../../../model/event.model';
import { ExaminationSessionService } from '../../../service/examination-session.service';
import { ExaminationService } from '../../../service/examination.service';

@Component({
  selector: 'app-dashboard-teacher-next-session',
  templateUrl: './dashboard-teacher-next-session.component.html',
  styleUrls: ['./dashboard-teacher-next-session.component.scss']
})
export class DashboardTeacherNextSessionComponent implements OnInit, OnDestroy {
  teacher: Teacher;
  nextEvent: nextEvent;
  nextEventService;
  student: any;
  defaultAvatar = environment.static + '/avatar.png';
  idSkype: any
  countdown: any;
  countdownStatus = 'in'
  formation: Formation = new Formation();
  duration;
  isLoaded = false;
  pollingObservable = null;

  private _unsubscribeAll: Subject<any> = new Subject<any>();

  constructor(
    private router: Router,
    private sanitizer: DomSanitizer,
    private formationService: FormationService,
    private authenticationService: AuthenticationService,
    private upcomingService: UpcomingService,
    private occurrenceService: OccurrenceService,
    private examinationSessionService: ExaminationSessionService,
    private examinationService: ExaminationService,
  ) { }

  ngOnInit() {
    this.teacher = this.authenticationService.currentUserSubject.value;
    setInterval(() => this.setCountdown(), 1000);
    // this.getNextOccurrences();
    this.getNextEvent();
    this.pollingObservable = interval(30000)
      .subscribe(i => {
        this.getNextEvent();
      });
  }

  /**
   * Definit le lien d'appel skype de l'élève
   */
  skypeLink() {
    if (this.student.user.id_skype) {
      this.idSkype = 'skype:' + this.student.user.id_skype + '?call';
      return this.sanitizer.bypassSecurityTrustUrl(this.idSkype);
    }
  }
  setStudent() {
    if (this.nextEvent.student) {
      this.student = this.nextEvent.student
    }
  }


  getNextEvent(): void {
    this.upcomingService.getUpcomingsNextEvent()
      .subscribe(nextEvent => {
        if (nextEvent) {
          this.nextEvent = nextEvent;
          this.setStudent();
        } else {
          this.nextEvent = null;
        }
        this.isLoaded = true;
      })
  }

  ngOnDestroy() {
    if (this.nextEventService) {
      this.nextEventService.unsubscribe();
    }
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
  }

  setCountdown() {
    if (this.nextEvent) {
      const _sessionDiff = moment(this.nextEvent.end).diff(this.nextEvent.start);
      const sessionDuration = moment.duration(_sessionDiff);
      let halfTime = null;
      if (sessionDuration.asHours() > 1) {
        const calc = sessionDuration.asHours() / 2;
        halfTime = moment(this.nextEvent.start).add(calc.toString(), 'hours')
      } else {
        halfTime = moment(this.nextEvent.start).add('15', 'minutes')
      }
      // debugger
      const now = moment();
      let diff = moment(this.nextEvent.start).diff(now);
      this.duration = moment.duration(diff);
      if (this.duration.asHours() < 0) {
        if (moment(now).isAfter(moment(this.nextEvent.end))) {
          this.countdownStatus = 'finish';
          diff = moment(now).diff(this.nextEvent.end);
          this.duration = moment.duration(diff);
        } else if (moment(now).isAfter(moment(halfTime))) {
          this.countdownStatus = 'from';
          diff = moment(now).diff(this.nextEvent.start);
          this.duration = moment.duration(diff);
          // Handle pour récupérer le prochain next session...
          //this.getNextOccurrences();
        } else {
          this.countdownStatus = 'from';
          diff = moment(now).diff(this.nextEvent.start);
          this.duration = moment.duration(diff);
        }
      } else {
        this.countdownStatus = 'in';
      }

      if (Math.ceil(this.duration.asDays()) > 1) {
        this.countdown = Math.ceil(this.duration.asDays()) + ' Days ';
      } else if (Math.floor(this.duration.asHours()) >= 1) {
        this.countdown = this.duration.hours() + ' Hours ' + this.duration.minutes() + ' Minutes';
      } else if (Math.floor(this.duration.asHours()) < 1) {
        this.countdown = this.duration.minutes() + 'min ' + this.duration.seconds() + 's';
      } else {
        this.countdown = Math.floor(this.duration.asHours()) + ' h ' + this.duration.minutes() + ' min ' + this.duration.seconds() + 's';
      }
    }
  }

  linkIsValid() {
    // le bouton skype est dispo à moins de 5 min avant le prochain cours ou pendant le cours (jusqu'à 30 min).
    if (this.duration && Math.floor(this.duration.asHours()) < 1 && this.duration.minutes() < 15 || this.countdownStatus === 'from') {
      return true
    }
    return false
  }

  joinClass() {
    if (this.nextEvent.instance == 'occurrence')
      this.patchData('is_teacher_provider_link_clicked');
    this.openTeamsLink();
  }

  openAssessment(): void {
    if (this.nextEvent.examination_version === '1') {
      this.router.navigateByUrl('lilate/assessment', { state: { data: { lilate: this.nextEvent } } });
    } else if (this.nextEvent.examination_version === '2') {
      this.examinationService.openSession(this.authenticationService.currentUserSubject.value.user.email, this.nextEvent.id, localStorage.getItem('access_token'), '_blank');
    }
  }

  patchData(data) {
    const params = {
      [data]: moment().toISOString(),
    }
    this.occurrenceService.patchObservableOccurrence(this.nextEvent.url, params).subscribe(occurrence => {
      if (occurrence) {
      }
    });
  }


  openTeamsLink() {
    if (this.nextEvent.provider_link) {
      if (this.nextEvent.instance === 'lilate') {
        if (this.nextEvent.examination_version === '1') {
          window.open(this.nextEvent.provider_link, '_blank');
        } else if (this.nextEvent.examination_version === '2') {
          this.examinationService.openSession(this.authenticationService.currentUserSubject.value.user.email, this.nextEvent.id, localStorage.getItem('access_token'), '_blank');
        }
      }
      else {
        window.open(this.nextEvent.provider_link, '_blank');
      }
    }
  }
}
